"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BonusTournamentsListCtl = /** @class */ (function (_super) {
    __extends(BonusTournamentsListCtl, _super);
    function BonusTournamentsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_is_published = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_published; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_is_req_player_level = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_req_player_level; });
        _this.dk_min_player_level_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_player_level_id; });
        _this.dk_min_player_level_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_player_level_title; });
        _this.dk_is_req_deposit_during_age = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_req_deposit_during_age; });
        _this.dk_deposit_age_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_age_type_code; });
        _this.dk_deposit_age_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_age_type_title; });
        _this.dk_is_req_deposit_amount_during_age = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_req_deposit_amount_during_age; });
        _this.dk_cms_gameset_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cms_gameset_id; });
        _this.dk_cms_gameset_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cms_gameset_title; });
        _this.dk_tournament_state_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.tournament_state_code; });
        _this.dk_tournament_state_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.tournament_state_title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_number_of_prizes = UIUtils_1.UIUtils.IProp2Str(function (o) { o.number_of_prizes; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_date_start = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_start; });
        _this.dk_date_end = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_end; });
        _this.dk_start_day = UIUtils_1.UIUtils.IProp2Str(function (o) { o.start_day; });
        _this.dk_start_month = UIUtils_1.UIUtils.IProp2Str(function (o) { o.start_month; });
        _this.dk_start_year = UIUtils_1.UIUtils.IProp2Str(function (o) { o.start_year; });
        _this.dk_start_hour = UIUtils_1.UIUtils.IProp2Str(function (o) { o.start_hour; });
        _this.dk_start_minute = UIUtils_1.UIUtils.IProp2Str(function (o) { o.start_minute; });
        _this.dk_start_second = UIUtils_1.UIUtils.IProp2Str(function (o) { o.start_second; });
        _this.dk_end_day = UIUtils_1.UIUtils.IProp2Str(function (o) { o.end_day; });
        _this.dk_end_month = UIUtils_1.UIUtils.IProp2Str(function (o) { o.end_month; });
        _this.dk_end_year = UIUtils_1.UIUtils.IProp2Str(function (o) { o.end_year; });
        _this.dk_end_hour = UIUtils_1.UIUtils.IProp2Str(function (o) { o.end_hour; });
        _this.dk_end_minute = UIUtils_1.UIUtils.IProp2Str(function (o) { o.end_minute; });
        _this.dk_end_second = UIUtils_1.UIUtils.IProp2Str(function (o) { o.end_second; });
        _this.dk_max_buys_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.max_buys_count; });
        _this.dk_freespin_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.freespin_count; });
        _this.dk_is_unlimited_buys_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_unlimited_buys_count; });
        _this.dk_is_for_developers_only = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_for_developers_only; });
        _this.dk_tournament_kind_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.tournament_kind_code; });
        _this.dk_tournament_kind_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.tournament_kind_title; });
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_is_req_min_bet = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_req_min_bet; });
        _this._errDialog = errDialog;
        return _this;
    }
    BonusTournamentsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    BonusTournamentsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "bonus tournament range with id [" + id + "] not found !";
    };
    BonusTournamentsListCtl.prototype.LoadData = function (data, onDone) {
        var _this = this;
        webAApi_1.ListBonusTournamentsByBrandIdGet.exec({
            all_brands: data.allBrands,
            brand_id_list: data.brands,
            from_day: data.from_day,
            from_month: data.from_month,
            from_year: data.from_year,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            //
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    is_published: resp.list[i].is_published,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    is_req_player_level: resp.list[i].is_req_player_level,
                    min_player_level_id: resp.list[i].min_player_level_id,
                    min_player_level_title: resp.list[i].min_player_level_title,
                    is_req_deposit_during_age: resp.list[i].is_req_deposit_during_age,
                    deposit_age_type_code: resp.list[i].deposit_age_type_code,
                    deposit_age_type_title: resp.list[i].deposit_age_type_title,
                    is_req_deposit_amount_during_age: resp.list[i].is_req_deposit_amount_during_age,
                    cms_gameset_id: resp.list[i].cms_gameset_id,
                    cms_gameset_title: resp.list[i].cms_gameset_title,
                    tournament_state_code: resp.list[i].tournament_state_code,
                    tournament_state_title: resp.list[i].tournament_state_title,
                    number_of_prizes: resp.list[i].number_of_prizes,
                    description: resp.list[i].description,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    date_start: moment(resp.list[i].date_start_uts_ms).utc(false),
                    date_end: moment(resp.list[i].date_end_uts_ms).utc(false),
                    start_day: resp.list[i].start_day,
                    start_month: resp.list[i].start_month,
                    start_year: resp.list[i].start_year,
                    start_hour: resp.list[i].start_hour,
                    start_minute: resp.list[i].start_minute,
                    start_second: resp.list[i].start_second,
                    end_day: resp.list[i].end_day,
                    end_month: resp.list[i].end_month,
                    end_year: resp.list[i].end_year,
                    end_hour: resp.list[i].end_hour,
                    end_minute: resp.list[i].end_minute,
                    end_second: resp.list[i].end_second,
                    max_buys_count: resp.list[i].max_buys_count,
                    freespin_count: resp.list[i].freespin_count,
                    is_unlimited_buys_count: resp.list[i].is_unlimited_buys_count,
                    is_for_developers_only: resp.list[i].is_for_developers_only,
                    tournament_kind_code: resp.list[i].tournament_kind_code,
                    tournament_kind_title: resp.list[i].tournament_kind_title,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    is_req_min_bet: resp.list[i].is_req_min_bet
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTournamentsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBonusTournament.exec({
            data: {
                title: data.title,
                brand_id: data.brand_id,
                is_req_player_level: data.is_req_player_level,
                min_player_level_id: data.min_player_level_id,
                is_req_deposit_during_age: data.is_req_deposit_during_age,
                deposit_age_type_code: data.deposit_age_type_code,
                is_req_deposit_amount_during_age: data.is_req_deposit_amount_during_age,
                cms_gameset_id: data.cms_gameset_id,
                number_of_prizes: data.number_of_prizes,
                description: data.description,
                start_day: data.start_day,
                start_month: data.start_month,
                start_year: data.start_year,
                start_hour: data.start_hour,
                start_minute: data.start_minute,
                start_second: data.start_second,
                end_day: data.end_day,
                end_month: data.end_month,
                end_year: data.end_year,
                end_hour: data.end_hour,
                end_minute: data.end_minute,
                end_second: data.end_second,
                max_buys_count: data.max_buys_count,
                freespin_count: data.freespin_count,
                is_unlimited_buys_count: data.is_unlimited_buys_count,
                is_for_developers_only: data.is_for_developers_only,
                tournament_kind_code: data.tournament_kind_code,
                app_currency_id: data.app_currency_id,
                is_req_min_bet: data.is_req_min_bet
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                title: data.title,
                is_published: false,
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                is_req_player_level: data.is_req_player_level,
                min_player_level_id: data.min_player_level_id,
                min_player_level_title: resp.min_player_level_title,
                is_req_deposit_during_age: data.is_req_deposit_during_age,
                deposit_age_type_code: data.deposit_age_type_code,
                deposit_age_type_title: resp.deposit_age_type_title,
                is_req_deposit_amount_during_age: data.is_req_deposit_amount_during_age,
                cms_gameset_id: data.cms_gameset_id,
                cms_gameset_title: resp.cms_gameset_title,
                tournament_state_code: resp.tournament_state_code,
                tournament_state_title: resp.tournament_state_title,
                description: data.description,
                number_of_prizes: data.number_of_prizes,
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                date_start: moment(resp.date_start_uts_ms).utc(false),
                date_end: moment(resp.date_end_uts_ms).utc(false),
                start_day: data.start_day,
                start_month: data.start_month,
                start_year: data.start_year,
                start_hour: data.start_hour,
                start_minute: data.start_minute,
                start_second: data.start_second,
                end_day: data.end_day,
                end_month: data.end_month,
                end_year: data.end_year,
                end_hour: data.end_hour,
                end_minute: data.end_minute,
                end_second: data.end_second,
                max_buys_count: data.max_buys_count,
                freespin_count: data.freespin_count,
                is_unlimited_buys_count: data.is_unlimited_buys_count,
                is_for_developers_only: data.is_for_developers_only,
                tournament_kind_code: data.tournament_kind_code,
                tournament_kind_title: resp.tournament_kind_title,
                app_currency_id: data.app_currency_id,
                app_currency_title: resp.app_currency_title,
                is_req_min_bet: data.is_req_min_bet
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTournamentsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBonusTournament.exec({
                data: {
                    bonus_tournament_id: data.key,
                    title: data.title,
                    is_req_player_level: data.is_req_player_level,
                    min_player_level_id: data.min_player_level_id,
                    is_req_deposit_during_age: data.is_req_deposit_during_age,
                    deposit_age_type_code: data.deposit_age_type_code,
                    is_req_deposit_amount_during_age: data.is_req_deposit_amount_during_age,
                    cms_gameset_id: data.cms_gameset_id,
                    number_of_prizes: data.number_of_prizes,
                    description: data.description,
                    start_day: data.start_day,
                    start_month: data.start_month,
                    start_year: data.start_year,
                    start_hour: data.start_hour,
                    start_minute: data.start_minute,
                    start_second: data.start_second,
                    end_day: data.end_day,
                    end_month: data.end_month,
                    end_year: data.end_year,
                    end_hour: data.end_hour,
                    end_minute: data.end_minute,
                    end_second: data.end_second,
                    max_buys_count: data.max_buys_count,
                    freespin_count: data.freespin_count,
                    is_unlimited_buys_count: data.is_unlimited_buys_count,
                    is_for_developers_only: data.is_for_developers_only,
                    tournament_kind_code: data.tournament_kind_code,
                    app_currency_id: data.app_currency_id,
                    is_req_min_bet: data.is_req_min_bet
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.is_req_player_level = data.is_req_player_level;
                _tmp.min_player_level_id = data.min_player_level_id;
                _tmp.min_player_level_title = resp.min_player_level_title;
                _tmp.is_req_deposit_during_age = data.is_req_deposit_during_age;
                _tmp.deposit_age_type_code = data.deposit_age_type_code;
                _tmp.deposit_age_type_title = resp.deposit_age_type_title;
                _tmp.is_req_deposit_amount_during_age = data.is_req_deposit_amount_during_age;
                _tmp.cms_gameset_id = data.cms_gameset_id;
                _tmp.cms_gameset_title = resp.cms_gameset_title;
                _tmp.number_of_prizes = data.number_of_prizes;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.date_start = moment(resp.date_start_uts_ms).utc(false);
                _tmp.date_end = moment(resp.date_end_uts_ms).utc(false);
                _tmp.description = data.description;
                _tmp.start_day = data.start_day;
                _tmp.start_month = data.start_month;
                _tmp.start_year = data.start_year;
                _tmp.start_hour = data.start_hour;
                _tmp.start_minute = data.start_minute;
                _tmp.start_second = data.start_second;
                _tmp.end_day = data.end_day;
                _tmp.end_month = data.end_month;
                _tmp.end_year = data.end_year;
                _tmp.end_hour = data.end_hour;
                _tmp.end_minute = data.end_minute;
                _tmp.end_second = data.end_second;
                _tmp.max_buys_count = data.max_buys_count;
                _tmp.freespin_count = data.freespin_count;
                _tmp.is_unlimited_buys_count = data.is_unlimited_buys_count;
                _tmp.is_for_developers_only = data.is_for_developers_only;
                _tmp.freespin_count = data.freespin_count;
                _tmp.freespin_count = data.freespin_count;
                _tmp.tournament_kind_code = data.tournament_kind_code;
                _tmp.tournament_kind_title = resp.tournament_kind_title;
                _tmp.is_req_min_bet = data.is_req_min_bet;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTournamentsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BonusTournamentsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBonusTournament.exec({ data: { bonus_tournament_id: key } }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTournamentsListCtl.prototype.DoSetIsPublished = function (key, isPublished, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoPublishBonusTournament.exec({ data: { bonus_tournament_id: key, is_published: isPublished } }, function (resp) {
                _tmp.is_published = isPublished;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTournamentsListCtl.prototype.DoCloneTournament = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoCloneTournament.exec({ data: { bonus_tournament_id: key } }, function (resp) {
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BonusTournamentsListCtl;
}(BaseController_1.BaseController));
exports.BonusTournamentsListCtl = BonusTournamentsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ctl/BonusTournamentsListCtl.ts
// module id = 1015
// module chunks = 0